import {
  IAutoComplete,
  ILinkData,
} from '@store/redux/features/search/searchSlice';

export function shouldShowHistory(
  recentSearches: string[] | undefined,
  recentViewed: ILinkData[] | undefined,
  autocompleteOptions: IAutoComplete[] | undefined,
) {
  return (
    (recentSearches && recentSearches.length > 0) ||
    (recentViewed && recentViewed.length > 0) ||
    (autocompleteOptions && autocompleteOptions.length > 0)
  );
}
